<div class="doc-block">
  <div class="doc-delete">
    <app-round-checkbox [extraClass]="'small bg-white'" [id]="document.docId" [isSelected]="document.selection.isSelected" (click)="selectByClick()"></app-round-checkbox>
  </div>
  <div class="doc-item" [classList]="document.selection.isSelected ? 'doc-item selected' : 'doc-item not-selected'">
    <div class="doc-img" *ngIf="document.status === 'anonymised' || document.status === 'error'">
      <a [routerLink]="['/image', document.docId]">
        <img [src]="document.thumbnail | secure | async" default="./assets/ui/png/broken_image.png">
      </a>
    </div>
    <div class="doc-progress" *ngIf="document.status === 'uploaded' || document.status === 'processing'">
      <div class="spinner">
        <app-spinnig-infinity-loader [matTooltip]="document.progress + ' %'" width="40"></app-spinnig-infinity-loader>
      </div>
      <div class="doc-progress-bar">
        <app-progress-bar [progress]="document.progress"></app-progress-bar>
      </div>
    </div>
    <div class="doc-stats">
      <div class="doc-item-name">
        <span class="file-name" [matTooltip]="document.name" [matTooltipDisabled]="document.name.length<11">{{document.name | slice:0:10}}</span>
        <span class="file-size">{{document.size | fileSize }}</span>
      </div>
      <div class="doc-button" *ngIf="document.status === 'anonymised'">
        <a [routerLink]="['/image', document.docId]" [state]="{ mode: 'edit' }"><img src="./assets/ui/svg/blue/Edit-icon.svg"></a>
        <a (click)="share()"><img src="./assets/ui/svg/blue/share-icon.svg"></a>
        <a (click)="download()"><img src="./assets/ui/svg/blue/Download-icon.svg"></a>
      </div>
    </div>
  </div>
</div>
